var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answers-survey-download"},[_c('span',{staticClass:"question"},[_c('strong',[_vm._v("Qual a nota você dá para esta solução inovadora?")]),_vm._v("\n    "+_vm._s(_vm.body.nps)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }